import { render, staticRenderFns } from "./educationExperience.vue?vue&type=template&id=19d87bac&scoped=true&"
import script from "./educationExperience.vue?vue&type=script&lang=js&"
export * from "./educationExperience.vue?vue&type=script&lang=js&"
import style0 from "./educationExperience.vue?vue&type=style&index=0&id=19d87bac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d87bac",
  null
  
)

component.options.__file = "educationExperience.vue"
export default component.exports